"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3772],{

/***/ 73772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ TilesWithIcons_TilesWithIcons; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
// EXTERNAL MODULE: ./node_modules/mobile-device-detect/dist/index.js
var dist = __webpack_require__(85088);
// EXTERNAL MODULE: ./src/components/Picture/index.ts + 1 modules
var Picture = __webpack_require__(17856);
;// CONCATENATED MODULE: ./src/blocks/TilesWithIcons/TilesWithIcons.tsx





const ALTERNATIVE_LAYOUT_NAME = "two_columns";
const TilesWithIcons = (param)=>{
    let { blockData  } = param;
    const { data  } = blockData;
    const { header , element ={} , layout , background ="#fff" , textColor ="#2A3030" , picture  } = data;
    const items = Object.values(element);
    const isAlternativeVersion = ALTERNATIVE_LAYOUT_NAME === layout;
    const containerStyle = {
        backgroundImage: "none",
        backgroundColor: background,
        color: textColor,
        backgroundSize: "cover",
        backgroundPositionY: "center"
    };
    if (picture && picture.publicUrl) {
        containerStyle.backgroundImage = "Url(".concat("https://www-api.coderslab.at/" + picture.publicUrl, ")");
    }
    const getClassForItem = ()=>{
        switch(items.length){
            case 1:
                return "tilesWithIcons__item--100";
            case 2:
                return "tilesWithIcons__item--50";
            case 3:
                return "tilesWithIcons__item--33";
            default:
                return "";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: containerStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tilesWithIcons__container",
            children: [
                header && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: header
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tilesWithIcons__list",
                    children: items.map((param, index)=>/*#__PURE__*/ {
                        let { title , content , picture  } = param;
                        return (0,jsx_runtime.jsxs)("div", {
                            className: "tilesWithIcons__item ".concat(getClassForItem(), " ").concat(isAlternativeVersion ? "tilesWithIcons__itemAlternative" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tileItem__icon",
                                    children: [
                                        picture && picture.publicUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                            data: picture
                                        }),
                                        !isAlternativeVersion && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                                                    query: "(max-width: 1339px)",
                                                    defaultMatches: dist.isMobile,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tileItem__icon--line"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                                                    query: "(min-width: 1340px)",
                                                    defaultMatches: !dist.isMobile,
                                                    children: index + 1 < items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tileItem__icon--line"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tileItem__content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: isAlternativeVersion ? "style-as-h2" : "style-as-h3",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tileItem__content--text",
                                            dangerouslySetInnerHTML: {
                                                __html: content
                                            }
                                        })
                                    ]
                                })
                            ]
                        }, "item_" + index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var TilesWithIcons_TilesWithIcons = (TilesWithIcons);

;// CONCATENATED MODULE: ./src/blocks/TilesWithIcons/index.ts



/***/ })

}]);